import clsx from 'clsx'

import type { CollapsibleProps } from '@wartek-id/collapsible-v1'
import { Collapsible } from '@wartek-id/collapsible-v1'

import styles from 'app/KinerjaShared/components/CardCollapsible/styles.module.css'

export function CardCollapsible({
  className,
  ...collapsibleProps
}: CollapsibleProps) {
  return (
    <Collapsible
      defaultOpen
      variant="card"
      className={clsx('bg-white', styles.root, className)}
      {...collapsibleProps}
    />
  )
}
